import { useLocation } from 'react-router-dom'
import axios from 'axios'
import * as ACTIONS from './store/actions/actions'

export function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export const getNumberOfWeek = () => {
  var dt = new Date()
  var tdt = new Date(dt.valueOf())
  var dayn = (dt.getDay() + 6) % 7
  tdt.setDate(tdt.getDate() - dayn + 3)
  var firstThursday = tdt.valueOf()
  tdt.setMonth(0, 1)
  if (tdt.getDay() !== 4) {
    tdt.setMonth(0, 1 + ((4 - tdt.getDay() + 7) % 7))
  }
  return 1 + Math.ceil((firstThursday - tdt) / 604800000)
}

export const getlegumes = (app, dispatch) => {
  const user = window.localStorage.getItem('user')
  let u = JSON.parse(user)
  axios
    .get(
      `https://extranet.biobreizh.org/wp-json/bb/v1/legumesByProducteur/${u.id}`
    )
    .then(function (response) {
      if (response.status === 200) {
        // Stocker les légumes avec le statut "rien à déclarer" 
        const legumesWithStatus = response.data.legumes
        legumesWithStatus.rien_a_declarer = response.data.rien_a_declarer
        dispatch(ACTIONS.setLegumes(legumesWithStatus))
      }
    })
    .catch(function (error) {
      console.log(error)
    })
}
